<section
  appInView
  (inView)="animateCards()"
  class="relative py-20 overflow-hidden"
>
  <!-- Glow accent in background -->
  <div
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/15 rounded-full blur-[160px] pointer-events-none"
  ></div>

  <app-content-container>
    <!-- Section Header -->
    <div class="flex flex-col items-center text-center mb-16 relative z-10">
      <h2 class="section-title">
        Pilares de
        <span class="angular-font-color">Inovação Frontend</span>
      </h2>

      <p class="section-description mt-6 max-w-[680px]">
        Arquitetura escalável, reatividade de última geração e IA aplicada para
        construir e sustentar aplicações prontas para o padrão global de
        engenharia.
      </p>
    </div>

    <!-- Pillars Grid -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto relative z-10"
    >
      @for (pillar of pillars; track pillar.id) {
      <div
        #pillarCard
        class="glass-card p-8 rounded-2xl border border-white/15 bg-[#131B2A]/90 backdrop-blur-xl relative overflow-hidden transition-all duration-300 shadow-2xl flex flex-col justify-between group {{ pillar.borderHoverClass }}"
      >
        <!-- Radial ambient glow inside card -->
        <div
          class="absolute -right-12 -top-12 w-48 h-48 rounded-full blur-3xl transition-opacity duration-300 opacity-30 group-hover:opacity-60 {{ pillar.glowColorClass }}"
        ></div>

        <div>
          <!-- Header inside card -->
          <div class="flex items-center justify-between mb-6">
            <div
              class="w-14 h-14 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300 shadow-lg"
            >
              <i [class]="pillar.iconClass"></i>
            </div>

            <span
              class="px-3 py-1 rounded-full text-xs font-mono font-bold border {{ pillar.badgeColorClass }}"
            >
              {{ pillar.badge }}
            </span>
          </div>

          <!-- Title & Description -->
          <h3
            class="text-2xl font-bold text-white mb-3 {{ pillar.titleHoverColorClass }} transition-colors duration-300"
          >
            {{ pillar.title }}
          </h3>

          <p class="text-gray-200 text-base leading-relaxed mb-6 font-normal">
            {{ pillar.description }}
          </p>
        </div>
      </div>
      }
    </div>
  </app-content-container>
</section>
